module.exports = __webpack_public_path__ + "img/drops-bg3.5f622da2.webp";